import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { ENetwork } from 'web3';

import { getDexGasPrice } from '../../api';
import { buildDexGasPriceQueryKey } from '../../const';
import { IGasPriceResponse } from '../../types';
import { useDexGasPriceStore } from '../stores';

type UseDexGasPriceArgs = {
  network: ENetwork;
};

export const useDexGasPrice = ({ network }: UseDexGasPriceArgs): IGasPriceResponse | undefined => {
  const gasPrice = useDexGasPriceStore(state => state.gasPrices[network]);
  const setGasPrice = useDexGasPriceStore(state => state.setGasPrice);

  const query = useQuery({
    queryKey: buildDexGasPriceQueryKey(network),
    queryFn: () => getDexGasPrice(network),
    enabled: !gasPrice,
    refetchOnReconnect: false,
  });

  useEffect(() => {
    if (query.data?.isSuccess) {
      setGasPrice(network, query.data.data);
    }
  }, [network, query.data, setGasPrice]);

  return gasPrice ?? query.data?.data;
};
